<template>
  <div>

    <Head />
    <div class="layout">
      <div class="platform">
        <div class="part-1">
          <div class="main">
            <div class="left">
              <p class="tit">区块链积分商城</p>
              <p class="text">将区块链技术应用于电商领域，搭建公开、透明的积分商城，形成良性竞争的商户生态圈</p>
            </div>
            <div class="right">
              <img
                src="../../../assets/images/pc/solution/part1-1.png"
                alt
              />
            </div>
          </div>
        </div>
        <div class="part-2">
          <div class="main">
            <p class="tit">方案介绍</p>
            <div class="content">
              <div class="line">
                为解决传统积分商城存在的活动规则不透明、暗箱操作等问题，恒为分析并结合市场需求，将区块链技术与传统电商相结合，利用区块链天然的防篡改技术特点，有效解决传统电商平台中存在的积分发行不透明、通兑过程繁琐、流通率低等问题。
              </div>
              <div class="line">
                区块链积分商城支持运营方和商户发行属于自己的区块链积分，并设计适合自身业务需求的积分发行、使用规则。运营方可通过区块链积分平台设定联盟商户的通用积分，商户间可自行规定积分通兑规则，实现积分在多个联盟商户内自由流转、通兑，提升消费者粘性，实现共享会员。通过区块链技术将积分规则上链，消费者可随时查看，不必再担心商户暗箱操作。
              </div>
              <div class="line">
                该方案旨在将区块链技术应用于电商领域，解决传统积分商城存在的问题，打造一个公开透明、业务模式灵活，有效助力商户突破营销瓶颈的区块链积分商城。
              </div>
              <div class="img">
                <img
                  src="../../../assets/images/pc/solution/pointsMall/part2.png"
                  alt=""
                >
              </div>
            </div>
          </div>
        </div>
        <div class="part-3">
          <div class="main">
            <p class="tit">方案价值</p>
            <div class="content">
              <div class="card">
                <div class="left">
                  <img
                    src="../../../assets/images/pc/solution/pointsMall/part3-1.png"
                    alt=""
                  >
                </div>
                <div class="right">
                  <p class="title">运营方受益</p>
                  <p class="txt">平台整合各方信息，利用区块链技术的特点对联盟数据进行统一管理，有效优化运营结构、提升运营效率</p>
                </div>
              </div>
              <div class="card">
                <div class="left">
                  <img
                    src="../../../assets/images/pc/solution/pointsMall/part3-2.png"
                    alt=""
                  >
                </div>
                <div class="right">
                  <p class="title">商家受益</p>
                  <p class="txt">商家受益：商家通过区块链积分平台发布更加公开可信的营销活动，亦可形成商户联盟实现相互引流、共享会员的良性竞争生态，突破现有营销瓶颈</p>
                </div>
              </div>
              <div class="card">
                <div class="left">
                  <img
                    src="../../../assets/images/pc/solution/pointsMall/part3-3.png"
                    alt=""
                  >
                </div>
                <div class="right">
                  <p class="title">消费者受益</p>
                  <p class="txt">基于区块链防篡改、全链追溯的技术特性，商城积分体系对于消费者完全公开透明，可有效保障消费者权益。同时，消费者可使用联盟商户积分，在联盟商户之间自由通兑，实现积分价值最大化</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="part-4">
          <div class="main">
            <p class="tit">应用案例</p>
            <div class="content">
              <swiper
                ref="mySwiper"
                :options="swiperOptions"
              >
                <swiper-slide>
                  <div class="card">
                    <div class="left">
                      <img
                        src="../../../assets/images/pc/solution/pointsMall/part4-11.png"
                        alt=""
                      >
                    </div>
                    <div class="right">
                      <p class="l1">物博通区块链积分商城</p>
                      <div class="l2">
                        物博通是以2018世界物联网博览会为背景，通过区块链来记录展商与观众间互动，传递价值的小程序。程序主要实现了展商和观众的名片互换、礼品兑换和大会推广等功能。通过区块链，展商以公开透明的方式来获取观众的名片信息和发放礼品；观众以名片互换的方式来获取积分和兑换礼品。展商和观众之间的互动完全透明，避免了活动奖品虚假摆设、内定中奖的现象。
                      </div>
                      <!-- <div class="l3">
                        <span class="s1">合作方：</span>
                        <img
                          src="../../../assets/images/pc/solution/pointsMall/part4-12.png"
                          alt=""
                        >
                        <span class="s2">呈信区块链科技（云南）有限责任公司 </span>
                        <span class="s3">上线时间：2019年6月</span>

                      </div> -->
                    </div>
                  </div>
                </swiper-slide>
              </swiper>
              <div
                class="swiper-pagination"
                slot="pagination"
              ></div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <Foot />
  </div>
</template>
<script>
import Head from "../../../components/pc/Head";
import Foot from "../../../components/pc/Foot";
import api from "../../../common/api";
import { Button } from "iview";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

export default {
  name: "service",
  components: {
    Head,
    Foot,
    Button,
    swiper,
    swiperSlide,
  },
  data() {
    return {
      cn: false,
      en: false,
      swiperOptions: {
        //swiper配置
        //autoplay: true,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true, //分页控制切换
        },
        // Some Swiper option/callback...
      },
    };
  },
  mounted() {
    this.mobile();
  },
  created() {
    this.getLang();
  },
  methods: {
    getLang() {
      if (localStorage.Lang == "en") {
        this.en = true;
      } else {
        this.cn = true;
      }
    },
    mobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      if ((flag && flag.length) > 0) {
        this.$router.replace("/mobile" + this.$route.path);
      }
    },
  },
};
</script>
<style  lang="less"  scoped>
@import url("../../../assets/css/var.less");
.layout {
  min-height: calc(100vh);
  // max-width:@max-width;
  min-width: @min-width;
  background-color: #f8f9fb;
}
.platform {
  .part-1 {
    width: 100%;
    .p1();
    background: linear-gradient(-30deg, #4d23ee, #4697fb);
    .main {
      .clearfix();
    }
    .left {
      width: 54%;
      float: left;
      .tit {
        .hTit();
        margin: 185px 0 25px 0;
      }
      .text {
         width: 510px;
        .hText();
      }
    }
    .right {
      width: 46%;
      float: left;
      img {
        margin: 62px 0 0 75px;
        width: 400px;
        height: 384px;
      }
    }
  }
  .part-2 {
    background: #fff;
    padding: 80px 0 80px;
    .main {
      .clearfix();
      height: 100%;
      padding: 0;
      .tit {
        .onlyTit();
      }
      .content {
        width: 100%;
        height: 100%;
        .line {
          font-size: 14px;
          line-height: 20px;
          margin-bottom: 15px;
        }
        .img {
          margin-top: 35px;
          text-align: center;
          img {
            width: 861px;
            height: auto;
          }
        }
      }
    }
  }

  .part-3 {
    padding: 80px 0 80px;
    background: #f9f9f9;
    .main {
      .clearfix();
      padding: 0;
      .tit {
        .onlyTit();
      }
      .content {
        width: 100%;
        .card {
          width: 1140px;
          height: 184px;
          display: flex;
          padding: 38px 20px;
          background: #ffffff;
          margin: 15px auto;
          box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
          .left {
            width: 179px;
            img {
              height: 100%;
              height: 108px;
            }
          }
          .right {
            padding: 25px 0 0 20px;

            .title {
              color: #444444;
              font-size: 20px;
              text-align: left;
              margin-bottom: 4px;
            }
            .txt {
              color: #888888;
              text-align: left;
              font-size: 14px;
            }
          }
        }
      }
    }
  }
  .part-4 {
    padding: 80px 0 80px;
    background: #ffffff;
    .main {
      .clearfix();
      padding: 0;
      .tit {
        .onlyTit();
      }
      .content {
        display: flex;
        flex-wrap: wrap;
        .card {
          height: 332px;
          background: #fff;
          box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
          margin: 10px;
          padding: 10px;
          display: flex;
          .left {
            width: 447px;
            img {
              height: 100%;
              width: 100%;
            }
          }
          .right {
            flex: 1;
            padding: 45px 42px 0 59px;
            .l1 {
              color: #444444;
              font-size: 20px;
            }
            .l2 {
              margin: 30px 0;
              color: #888888;
              font-size: 14px;
              line-height: 24px;
            }
            .l3 {
              color: #888888;
              font-size: 14px;
              height: 32px;
              span {
                display: inline-block;
                height: 32px;
                line-height: 32px;
              }
              img {
                vertical-align: top;
                width: 32px;
                height: 32px;
                margin-right: 10px;
              }
              .s3 {
                margin-left: 30px;
              }
            }
          }
        }
        .swiper-pagination {
          position: static; //取消定位
          display: block;
          margin: 30px auto 0;
          /deep/.swiper-pagination-bullet {
            background: #d4d4d4;
            margin: 0 5px;
            opacity: 1;
            outline: none; //清除点击突出的边框
          }
          /deep/.swiper-pagination-bullet-active {
            background: #2a93ff;
            position: relative;
            top: -2px;
            width: 28px;
            height: 4px;
            border-radius: 5px;
            opacity: 1;
            outline: none;
          }
        }
      }
    }
  }
}
</style>